import { Link } from "react-router-dom";
import { buildWhatsAppLink } from "@/lib/whatsapp";
import { Logo } from "@/components/site/Logo";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0a0a0a] text-white pt-20 md:pt-28 pb-10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-5">
            <div data-testid="footer-logo">
              <Logo size="lg" className="rounded-[2px]" />
            </div>
            <p className="font-display text-2xl md:text-3xl leading-snug mt-10 max-w-md">
              Método, dados e direção
              <br />
              para a nova geração da beleza.
            </p>
            <a
              href={buildWhatsAppLink(
                "Olá! Quero conhecer as próximas turmas da Oasys Academy.",
              )}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-cta-whatsapp"
              className="btn-ghost-light mt-10"
            >
              Falar com a Academy
              <span aria-hidden>→</span>
            </a>
          </div>

          <div className="md:col-span-3">
            <p className="eyebrow text-white/50">Navegar</p>
            <ul className="mt-6 space-y-3 text-[15px]">
              <li>
                <a href="/#academy" className="hover:text-[#f4c542] transition-colors">
                  Academy
                </a>
              </li>
              <li>
                <a href="/#macd" className="hover:text-[#f4c542] transition-colors">
                  Método MACD
                </a>
              </li>
              <li>
                <a
                  href="/#formacoes"
                  className="hover:text-[#f4c542] transition-colors"
                >
                  Formações
                </a>
              </li>
              <li>
                <a href="/#gilson" className="hover:text-[#f4c542] transition-colors">
                  Fundador
                </a>
              </li>
              <li>
                <a
                  href="/#insights"
                  className="hover:text-[#f4c542] transition-colors"
                >
                  Insights
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="eyebrow text-white/50">Insights editoriais</p>
            <ul className="mt-6 space-y-3 text-[15px]">
              <li>
                <Link
                  to="/insights/movimento-nao-e-crescimento"
                  className="hover:text-[#f4c542] transition-colors"
                >
                  Movimento não é crescimento
                </Link>
              </li>
              <li>
                <Link
                  to="/insights/a-decisao-saiu-da-cadeira"
                  className="hover:text-[#f4c542] transition-colors"
                >
                  A decisão saiu da cadeira
                </Link>
              </li>
              <li>
                <Link
                  to="/insights/cliente-esquecida-e-faturamento-perdido"
                  className="hover:text-[#f4c542] transition-colors"
                >
                  Cliente esquecida é faturamento perdido
                </Link>
              </li>
              <li>
                <Link
                  to="/insights/dados-sao-memoria-do-relacionamento"
                  className="hover:text-[#f4c542] transition-colors"
                >
                  Dados são memória do relacionamento
                </Link>
              </li>
              <li>
                <Link
                  to="/insights/o-salao-que-nao-le-comportamento-cresce-no-escuro"
                  className="hover:text-[#f4c542] transition-colors"
                >
                  O salão que não lê comportamento
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-[12px] tracking-[0.18em] uppercase text-white/50">
            © {new Date().getFullYear()} Oasys Academy · Todos os direitos reservados
          </p>
          <p className="text-[12px] tracking-[0.18em] uppercase text-white/50">
            Fundado por Gilson Ribeiro · Oasys Hair
          </p>
        </div>
      </div>
    </footer>
  );
};
